export const osInjectionKey = Symbol("osInjectionKey");
export const platformInjectionKey = Symbol("platformInjectionKey");
